import router from '@/router'
import appConstants from '@/constants/constants'

export const openChat = chatType => {
  if (
    (
      router.currentRoute.name !== appConstants.router.chat.APP_USER_CHAT
      && appConstants.chat.type.COLLEAGUES === chatType
    )
    || (
      router.currentRoute.name !== appConstants.router.chat.APP_PATIENT_CHAT
      && appConstants.chat.type.PATIENTS === chatType
    )
    || (
      router.currentRoute.name !== appConstants.router.chat.APP_MIMIRMAN_CHAT
      && appConstants.chat.type.MIMIRMAN === chatType
    )
  ) {
    let route = null
    switch (chatType) {
      case appConstants.chat.type.COLLEAGUES:
        route = appConstants.router.chat.APP_USER_CHAT
        break
      case appConstants.chat.type.PATIENTS:
        route = appConstants.router.chat.APP_PATIENT_CHAT
        break
      case appConstants.chat.type.MIMIRMAN:
        route = appConstants.router.chat.APP_MIMIRMAN_CHAT
        break
    }
    if (route) {
      router.push({name: route})
    }
  }
}
